
import React from "react";

interface TooltipProviderProps {
  children: React.ReactNode;
  className?: string;
}

export function TooltipProvider({ children, className = "" }: TooltipProviderProps) {
  return <div className={className}>{children}</div>;
}
